/**
 * Education page
 * WARNING: May want to fetch links using API in future
 */
import React from "react";
import EducationCard from "../components/education/EducationCard";
import CoreBanner from "../components/core/CoreBanner";
import Container from "../components/core/Container";
import { Helmet } from "react-helmet-async";

const Education = () => {
  const data = [
    {
      name: "Program Overview",
      link: "/approach",
      desc: "Learn about the BUIHA Education Program",
    },
    {
      name: "Body Contact",
      link: "/body-contact",
      desc: "Learn about safe body contact in Ice Hockey",
    },
    {
      name: "Skills Development",
      link: "/skills",
      desc: "An overview of how to introduce fundamental skills",
    },
    {
      name: "Injury Prevention",
      link: "/injury-prevention",
      desc: "An overview of preventing injuries in Ice Hockey",
    },
    {
      name: "Injury Reporting Form",
      link: "https://forms.office.com/e/nYAMzuh4q6",
      external: true,
      desc: "Report an injury to help us improve player safety",
    },
    {
      name: "Concussion Recognition",
      link: "https://buiha.org.uk/assets/img/education/PocketConcussionRecognitionTool5.pdf",
      external: true,
      desc: "Learn to recognise the signs of concussion",
    },
    {
      name: "Medical History Form",
      link: "https://buiha.org.uk/assets/img/education/PlayerHealthForm.pdf",
      external: true,
      desc: "A form for clubs collecting player medical information",
    },
    {
      name: "Warm Up Guide",
      link: "https://buiha.org.uk/assets/img/education/BUIHA-WarmUpGuide.pdf",
      external: true,
      desc: "A guide for constructing an effective warm-up",
    }

  ]

  return (
    <div className="flex flex-row flex-wrap justify-center items-center">
      <Helmet>
        <title>Education | BUIHA</title>
        <meta
          name="description"
          content={`Education resources for the British Universities Ice Hockey Association (BUIHA)`}
        />
        <link rel="canonical" href={`https://buiha.org/education`} />
        <link rel="icon" type="image/png" href="/favicon.png" />
      </Helmet>
      
      <CoreBanner title="Education" />

      <Container children={

        <div className="bg-light-1 py-4 dark:bg-dark-1 flex flex-wrap items-center justify-center xl:flex-row">


          {data.map((resource) => (


            <EducationCard
              link={resource.link}
              name={resource.name}
              desc={resource.desc}
              external={resource.external}
            />
          ))}
        </div>

      } />
    </div>
  );
}
export default Education;